<template>
  <div class="filter-item-wrapper form__numericMinMaxInput">
    <label
      :for="'input_' + identifier"
      class="label"
      v-html="label"
      :title="title || label"
    />
    <NumericInput
      :placeholder="$tv('from', 'categories')"
      v-model="val"
      :format="'n2'"
      :disabled="disabled"
      :id="'input_' + identifier"
    />
  </div>
</template>

<script>
import NumericInput from '~/components/input-components/NumericInput'
import {VALUE_TYPES} from '~/assets/js/filters'

export default {
  name: 'AttributeFilterNumber',
  components: {
    NumericInput
  },
  props: {
    format: {
      type: String,
      required: true,
      default () {
        return ''
      }
    },
    label: {
      type: String,
      required: true,
      default () {
        return ''
      }
    },
    title: {
      type: String,
      required: false,
      default () {
        return null
      }
    },
    identifier: {
      type: Number,
      required: true,
      default () {
        return 0
      }
    },
    selectedValues: {
      type: [Object, null],
      required: true,
      default() {
        return null
      }
    },
    disabled: {
      type: Boolean,
      default() {
        return false
      }
    },
    localizedMeasure: {
      type: [String, Object],
      default() {
        return null
      }
    }
  },
  data() {
    return {
      valMM: undefined,
      valInch: undefined
    }
  },
  computed: {
    getFormat() {
      if (this.format === VALUE_TYPES.FLOAT || this.format === VALUE_TYPES.MULTI_DOUBLE) {
        return this.localizedMeasure === 'inch' ? 'n3' : 'n2'
      }
      else {
        return 'n0'
      }
    },
    val: {
      get() {
        if (this.localizedMeasure === 'inch') {
          return this.valInch
        } else {
          return this.valMM
        }
      },
      set(val) {
        this.setValue(val)
        this.$emit('input-value', {value: this.validateInput(this.valMM)})
      }
    }
  },
  watch: {
    selectedValues: {
      deep: true,
      immediate: true,
      handler() {
        this.valMM = this.selectedValues?.value
        // eslint-disable-next-line eqeqeq
        if (this.selectedValues?.value != null) {
          this.valInch = Number.parseFloat((this.selectedValues.value / 25.4).toFixed(4))
        }
      }
    }
  },
  methods: {
    setValue(val) {
      this.valInch = val
      this.valMM = val
      if (val && this.localizedMeasure === 'inch') {
        this.valMM = Number.parseFloat((val * 25.4).toFixed(4))
      } else if (val && this.localizedMeasure === 'mm') {
        this.valInch = Number.parseFloat((val / 25.4).toFixed(2))
      }
    },
    validateInput(value) {
      const val = Number.parseFloat(value)
      if (Number.isNaN(val))
      {
        return null
      }
      else {
        return val
      }
    }
  }
}
</script>

<style lang="scss">
.filter-item-wrapper.form__numericMinMaxInput {
  .form__numericInput {
    width: calc(100% - .3125rem);
  }
}
</style>
